<template>
    <div class="usermgmt-service">
        <div class="usermgmt-service__header flex flex--align-center flex--justify-between" style="margin-bottom: 28px">
            <v-item-title title="服务管理"></v-item-title>
            <v-icon type="iconarrow_circle_down-24px1"
                v-if="serviceList.length"
                @click.native="handleRecordShow"
                right-text="调用记录查询"></v-icon>
        </div>
        <div class="flex usermgmt-service__search">
            <Input class="usermgmt-service__customer__input" 
                prefix="ios-search"
                placeholder="用户ID, 用户名"
                @on-focus="handleInputFocus"
                @on-blur="handleInputBlur"
                @on-change="handleCustomerInput"
                v-model="customerSearchTerm"
            />
            <div class="usermgmt-service__customer__search" :hidden="!inputFocused || !customerSearchTerm">
                <div v-for="item in userSearchResult" :key="item.phone"
                    class="usermgmt-service__customer__search__item"
                    @click.stop="handleSelectUser(item)"
                    tabindex="-1"
                >
                    <div class="service__customer__search__item__phone">{{ item.phoneStrPre }}<span style="color: #7C4DFF">{{ item.phoneStrHighlight }}</span>{{ item.phoneStrPost }}</div>
                    <div class="service__customer__search__item__other">{{ item.otherStrPre }}<span style="color: #7C4DFF">{{ item.otherStrHighlight }}</span>{{ item.otherStrPost }}</div>
                </div>
            </div>
        </div>
        <div class="usermgmt-service__body">
            <v-loading :loading="loading"></v-loading>
            <user-service
                v-if="serviceList.length > 0"
                :list="serviceItemList"
                :serviceList="serviceList"
                :total="total"
                @update-service-item-list="handleUpdateServiceItemList"
            ></user-service>
            <v-no-data v-else></v-no-data>
        </div>

        <ServerRecord
            :serviceList="serviceList"
            :visible.sync="recordVisible"
            :get-service-log-func="getServiceLogFunc"></ServerRecord>
    </div>
</template>

<script>
import { fuzzySearchWithRole } from "@/api/user/user.js";
import { getBuyService, getMyServiceDataByUserId, getServiceLog } from '@/api/application/service';
import UserService from "@/components/b-components/userService/userService.vue";
import ServerRecord from '@/views/application/myService/serverRecord.vue';
import { debounce } from "lodash";

export default {
    components: {
        UserService,
        ServerRecord
    },
    data() {
        return {
            userSearchResult: [],
            selectedUser: null,
            customerSearchTerm: '',
            inputFocused: false,

            loading: false,
            serviceList: [],
            serviceItemList: [],
            total: 0,

            recordVisible: false,
        }
    },
    methods: {
        handleInputFocus(e) {
            this.inputFocused = true;
        },
        handleInputBlur(e) {
            if (e.relatedTarget && e.relatedTarget.className === 'usermgmt-service__customer__search__item')
                return;
            this.inputFocused = false;
        },
        handleCustomerInput: debounce(async function(e) {
            this.customerSearchTerm = e.target.value;
            this.userSearchResult = await fuzzySearchWithRole(this.customerSearchTerm);
            this.userSearchResult.forEach(item => {
                const phoneStr = item.phone.toString();
                const otherStr = `用户名: ${item.full_name} | Email: ${item.email}`;
                const phoneMatchIdx = phoneStr.indexOf(this.customerSearchTerm);
                const otherMatchIdx = otherStr.indexOf(this.customerSearchTerm);
                item.phoneStrPre = '';
                item.phoneStrHighlight = '';
                item.phoneStrPost = phoneStr;
                if (phoneMatchIdx > -1) {
                    item.phoneStrPre = phoneStr.substring(0, phoneMatchIdx);
                    item.phoneStrHighlight = this.customerSearchTerm;
                    item.phoneStrPost = phoneStr.substring(phoneMatchIdx + this.customerSearchTerm.length);
                }
                item.otherStrPre = '';
                item.otherStrHighlight = '';
                item.otherStrPost = otherStr;
                if (otherMatchIdx > -1) {
                    item.otherStrPre = otherStr.substring(0, otherMatchIdx);
                    item.otherStrHighlight = this.customerSearchTerm;
                    item.otherStrPost = otherStr.substring(otherMatchIdx + this.customerSearchTerm.length);
                }
            });
        }, 400),
        handleSelectUser(item) {
            this.customerSearchTerm = item.phone;
            this.inputFocused = false;
            this.userSearchResult = [item];
            this.selectedUser = item;
            this.getBuyService();
        },
        async getBuyService() {
            this.loading = true;
            const res = await getBuyService({
                finished: 1,
                user_id: this.selectedUser.id,
            });
            if (res) {
                this.serviceList = res.map((item) => Object.assign(item, {
                    id: String(item.id),
                }));
            }
            this.loading = false;
        },
        async handleUpdateServiceItemList(params) {
            this.loading = true;
            const res = await getMyServiceDataByUserId({
                ...params,
                user_id: this.selectedUser.id,
            });
            if (res) {
                this.serviceItemList = res.data_list;
                this.total = res.total;
            }
            this.loading = false;
        },
        handleRecordShow() {
            this.recordVisible = true;
        },
        async getServiceLogFunc(params) {
            params.user_id = this.selectedUser.id;
            const res = await getServiceLog(params);
            return res;
        },
    }
}
</script>

<style lang="less">
    @prefix: ~'usermgmt-service';
    .@{prefix} {
        padding: 16px;

        &__search-btn {
            width: 112px;
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            color: white;
        }

        &__search {
            margin-bottom: 24px;
            position: relative;
        }

        &__customer {
            &__input {
                border-radius: 8px;
            }

            &__search {
                position: absolute;
                top: calc(100% + 4px);
                // left: 8px;
                z-index: 1000;
                width: 752px;
                height: 168px;
                overflow-y: auto;
                border-radius: 8px;
                background: white;
                box-shadow: 0 24px 38px 3px rgba(black, 0.1), 0 9px 46px 8px rgba(black, 0.08), 0 11px 15px 0 rgba(black, 0.16);
                border: 1px solid rgba(black, 0.08);
                padding: 8px;

                &__item {
                    width: 728px;
                    height: 48px;
                    border-radius: 8px;
                    padding: 8px 16px;

                    &:hover {
                        cursor: pointer;
                        background: rgba(black, 0.08);
                    }

                    &__phone {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 16px;
                        color: rgba(black, 0.87);
                    }

                    &__other {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        color: rgba(black, 0.54);
                    }
                }
            }
        }
        &__body {
            position: relative;
        }
        &__header {
            & .v-icon{
                color: rgba(0, 0, 0, 0.54);
                &:hover{
                cursor: pointer;
                color: @primary-color;
                }
                .icon-right-text{
                font-weight: 500;
                }
            }
        }
        
    }
</style>